import { ReactElement } from "react";
import { useAuth } from "react-oidc-context"
import { Outlet } from "react-router-dom";
import Loader from "./Loader/Loader";

interface IProps {
  children: ReactElement<any, any>;
}

function PrivateRoute({
  children,
}: IProps) {
  const auth = useAuth()

  if (auth.isLoading) {
    return (
      <Loader />
    )
  }

  if (auth.error) {
    if (auth.error.message === 'Failed to fetch'
      || auth.error.message === 'No matching state found in storage'
      || auth.error.message === 'Session not active'
      || auth.error.message === 'Token is not active'
      || auth.error.message === 'Invalid refresh token'
      || auth.error.message === 'authority mismatch on settings vs. signin state'
    ) {
      auth.signinRedirect();
    }
    return (
      <div>
        <h1>Oops ...</h1>
        <h1>{auth.error.message}</h1>
        <h1>{auth.error.stack}</h1>
      </div>
    )
  }

  if (!auth.isAuthenticated) {
    auth.signinRedirect();
    return <Outlet />;
  }

  return children ? children : <Outlet />;
}

export default PrivateRoute
